export default __webpack_public_path__ + "static/media/button-background.0312755a.png";